import { FILE_TYPE } from "@/config/constants";
import API from "@/lib/httpModule";

/**
 * upload image
 * @returns
 */
export const apiUploadImage = async ({ is_public = true, type = FILE_TYPE.MAIN, file }) => {
	const response = await API.post_origin(
		"/file",
		{ is_public, type, file },
		{ "Content-Type": "multipart/form-data" },
	);
	return response.data;
};

/**
 * upload public file
 * @returns
 */
export const apiUploadPublicFile = async ({ file }) => {
	const response = await API.post_origin("/file/public", { file }, { "Content-Type": "multipart/form-data" });
	return response.data;
};

/**
 * Get settings empty leg alert
 * @returns
 */
export async function getEmptyLegsAlert(query) {
	return API.get(`/user/empty-leg-alert`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}

/**
 * Detete empty leg alert
 * @returns
 */
export async function deleteEmptyLegsAlert(alertId) {
	return API.delete(`/user/empty-leg-alert/${alertId}`)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}

/**
 * Set setting empty leg alert
 * @returns
 */
export async function setEmptyLegsAlert(payload) {
	return API.post(`/user/empty-leg-alert`, payload)
		.then(async (rs) => {
			if (rs && rs.data.success) {
				const response = rs.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}

/**
 * Update setting empty leg alert
 * @returns
 */
export async function updateEmptyLegsAlert(alertId, payload) {
	return API.put(`/user/empty-leg-alert/${alertId}`, payload)
		.then(async (rs) => {
			if (rs && rs.data.success) {
				const response = rs.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}

/**
 * Set setting email notifications
 * @returns
 */
export async function getuserDetail(payload) {
	return API.post(`/user/email-notifications`, payload)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}

/**
 * Add user contact
 * @returns
 */
export async function createUserContact(payload) {
	return API.post_origin(`/contact`, payload)
		.then(async (rs) => {
			return { success: true };
		})
		.catch((errRes) => {
			return {
				success: false,
			};
		});
}

/**
 * Get all page content
 * @returns
 */
export async function getAllPageContent() {
	return API.get(`/page`)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}

/**
 * Get page content by slug
 * @returns
 */
export async function getPageContentBySlug(slug, preview = false, uid) {
	return API.get_origin(`/page/slug/${slug}?preview=${preview}&aircraft_type_slug=${uid}`)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}

export async function unsubscribeRecipient(token, payload) {
	return API.put_origin(`/p/recipients/unsubscribe?token=${token}`, payload)
		.then(async (rs) => {
			if (rs && rs.data.success) {
				return { success: true, data: rs.data };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				data: {},
				errors: errRes,
			};
		});
}
